import { Button } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import { useResetSearch } from './useResetSearch';

function ClearSearchButton() {
  const resetSearch = useResetSearch();

  return (
    <Button
      size="sm"
      variant="outlined"
      data-intercom-target="discovery-portal-clear-search-button"
      onClick={resetSearch}
    >
      <T kind="Clear search" />
    </Button>
  );
}

export default observer(ClearSearchButton);
